export default {
  titleMarginMedium: '0 0 6px 0',
  titleMarginLarge: '-2px 0 6px 0',
  titleFontSizeMedium: '14px',
  titleFontSizeLarge: '16px',
  iconSizeMedium: '14px',
  iconSizeLarge: '14px'
}
